export const GOVGR_ACCORDION = "govgr-accordion";
export const GOVGR_ACCORDION__SECTION_CONTENT =
  "govgr-accordion__section-content";
export const GOVGR_LIST = "govgr-list";
export const GOVGR_LINK__NO_UNDERLINE = "govgr-link--no-underline";
export const GOVGR_ACCORDION__SECTION_NO_BORDER =
  "govgr-accordion__section_no_border";
export const GOVGR_ACCORDION__SECTION_SUMMARY =
  "govgr-accordion__section-summary";
export const GOVGR_ACCORDION__SECTION_HEADING =
  "govgr-accordion__section-heading";
export const GOVGR_ACCORDION__SECTION_BUTTON =
  "govgr-accordion__section-button";
export const GOVGR_ACCORDION__SECTION_BUTTON_NOICON =
  "govgr-accordion__section-button-noIcon";
